// src/lib/schemas/item.ts
import * as Yup from 'yup';

export const itemSchema = Yup.object().shape({
  itemType: Yup.string()
    .oneOf(['service', 'goods'], 'Invalid item type')
    .required('Item type is required'),
  itemName: Yup.string()
    .min(2, 'Item name must be at least 2 characters')
    .max(100, 'Item name must not exceed 100 characters')
    .required('Item name is required'),
  sacCode: Yup.string().when('itemType', {
    is: 'service',
    then: (schema) =>
      schema
        .matches(/^\d{6}$/, 'SAC Code must be exactly 6 digits')
        .required('SAC Code is required for services'),
    otherwise: (schema) => schema.notRequired(),
  }),
  hsnCode: Yup.string().when('itemType', {
    is: 'goods',
    then: (schema) =>
      schema
        .matches(/^\d{4,8}$/, 'HSN Code must be 4-8 digits')
        .required('HSN Code is required for goods'),
    otherwise: (schema) => schema.notRequired(),
  }),
  taxPreference: Yup.string()
    .oneOf(['taxable', 'non-taxable', 'non-gst-supply', 'out-of-scope'], 'Invalid tax preference')
    .required('Tax preference is required'),
  sellingPrice: Yup.number()
    .min(0, 'Selling price must be a positive number')
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value)),
  currency: Yup.string().required('Currency is required'),
  description: Yup.string().max(500, 'Description must not exceed 500 characters'),
});
